import React from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

function AdArea({ className = '', id, zoneName }) {
  return (
    <div
      id={id}
      className={classnames('new-download-item-page__ad-area', className)}
      data-fuse={zoneName}
    />
  )
}

AdArea.propTypes = {
  className: string,
  id: string.isRequired,
  zoneName: string.isRequired,
}

export default AdArea
